import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_V2 } from '../api.conf';
import { Appointment } from '../../models/backend/appointment';
import { DraftAppointmentPayload } from '../../interfaces';
import { ActivatePublicDraftAppointmentRequestDTO } from '@paymash/sdk/dto/request';
import { PublicAppointmentResponseDTO } from '@paymash/sdk/dto/response';

@Injectable()
export class AppointmentApiService {
  constructor(private http: HttpClient, @Inject(API_V2) private api: string) {}

  private get basePath() {
    return `${this.api}/public`;
  }

  getAppointment(companyUuid: string, appointmentUuid: string): Observable<Appointment> {
    return this.http.get<Appointment>(`${this.basePath}/companies/${companyUuid}/appointments/${appointmentUuid}`);
  }

  activateAppointment(companyUuid: string, appointmentUuid: string, payload: ActivatePublicDraftAppointmentRequestDTO): Observable<PublicAppointmentResponseDTO> {
    return this.http.patch<PublicAppointmentResponseDTO>(
      `${this.basePath}/companies/${companyUuid}/appointments/${appointmentUuid}/activate`,
      payload
    );
  }

  createDraftAppointment(companyUuid: string, payload: DraftAppointmentPayload): Observable<Appointment> {
    return this.http.post<Appointment>(`${this.basePath}/companies/${companyUuid}/appointments`, payload);
  }

  deleteAppointment(companyUuid: string, appointmentUuid: string) {
    return this.http.delete(`${this.basePath}/companies/${companyUuid}/appointments/${appointmentUuid}`);
  }
}
